import { observer } from "mobx-react";
import useStore from "../../../store";
import { useEffect, useState } from "react";
import PageHeader from '../../../component/PageHeader';
import { Form, Input, Spin } from 'antd';
import InputComponent from "../../../component/InputComponent";
import { BookingInvoiceBreadcrumb } from "../../../config/BreadcrumbConfig";
import ListComponent from "./Component/ListComponent";

const BookingInvoices = observer(() => {
	const { BOOKINGINVOICE } = useStore();
	const { PAYMENT } = useStore();
	const {
		PAYMENT:{
			getMerchantwisePropertyList,
			propertyList
		}
	} = useStore();
	const [merchantLookupLoading, setMerchantLookupLoading] = useState(true);
	const {
		ACCOMMODATION: {
			getMerchantLookupList,
			merchantLookupList,
			merchantDetail
		},
	} = useStore();


	const handleKeyDown = (event) => {
		if (event.key === ' ') {
			event.stopPropagation();
		}
	};

	const onSearch = (text) => {
		if (text.length >= 3 || text.length === 0) {
			BOOKINGINVOICE.searchValue = text;
			BOOKINGINVOICE.setupGrid(BOOKINGINVOICE.agGrid);
		}
	};
	useEffect(() => {
		return () => {
			BOOKINGINVOICE.searchValue = '';
			BOOKINGINVOICE.merchantId = '';
    		BOOKINGINVOICE.propertyId = '';
    		PAYMENT.propertyList = [];
		};
	}, []);
	return (
		<div className="mainPageWrap">
			<PageHeader
				className="mainPageHeader"
				title={BookingInvoiceBreadcrumb.title}
				extra={[
					<Form.Item help={'Write 3 letters to search'} key={1}>
						<Input
							placeholder="Search here"
							onChange={(e) => onSearch(e.target.value)}
						/>
					</Form.Item>,
					<Form.Item key={2}>
						<InputComponent
							type="select"
							showSearch={true}
							name="eMerchantId"
							placeholder="Select Merchant Name"
							value={BOOKINGINVOICE.merchantId}
							onInputKeyDown={handleKeyDown}
							onChange={(value) => {
									BOOKINGINVOICE.merchantId = value;
									BOOKINGINVOICE.propertyId = '';
									getMerchantwisePropertyList(value)
									BOOKINGINVOICE.setupGrid(BOOKINGINVOICE.agGrid);
							}}
							onFocus={() =>
								merchantLookupLoading &&
								getMerchantLookupList().then(() =>
									setMerchantLookupLoading(false)
								)
							}
							notFoundContent={
								merchantLookupLoading ? (
									<Spin size="small" />
								) : (
									'Enter to add new'
								)
							}
							options={{
								values:
									(merchantLookupList.length &&
										merchantLookupList) ||
									(merchantDetail && [
										{
											eMerchantId:
												merchantDetail &&
												merchantDetail.id &&
												merchantDetail.id,
											merchantName:
												merchantDetail &&
												merchantDetail.merchantName &&
												merchantDetail.merchantName,
										},
									]),
								value_key: 'eMerchantId',
								text_key: 'merchantName',
							}}
							style={{ width: '200px', textAlign: 'left' }}
						/>
					</Form.Item>,
					<Form.Item key={3} >
						<InputComponent
							key={`dropdown-${BOOKINGINVOICE.merchantId}`}
							type="select"
							showSearch={true}
							name="ePropertyId"
							placeholder="Select Property Name"
							disabled ={!BOOKINGINVOICE.merchantId}
							value={BOOKINGINVOICE.propertyId}
							onInputKeyDown={handleKeyDown}
							onChange={(value) => {
							BOOKINGINVOICE.propertyId = value;
							BOOKINGINVOICE.setupGrid(BOOKINGINVOICE.agGrid);
							}}
							onFocus={() => {
								if (BOOKINGINVOICE.merchantId) {
								PAYMENT.getMerchantwisePropertyList(BOOKINGINVOICE.merchantId);
								}
							}}
							notFoundContent={
								!Array.isArray(propertyList) || propertyList.length === 0 ? (
								<Spin size="small" />
								) : (
								'No properties found'
								)
							}
							options={{
								values: Array.isArray(propertyList) ? propertyList : [],
								value_key: 'ePropertyId',
								text_key: 'propertyName'
							}}
							style={{ width: '200px', textAlign: 'left' }}
						/>
					</Form.Item>
				]}
			/>
			<ListComponent/>
		</div>
	);
});

export default BookingInvoices;